import "./ContactRequestAQuote.module.css";
import Navbar from "@/reusable_sections/Header";
import Quote from "./sections/Quote";
import Footer from "@/reusable_sections/Footer";
export default function ContactRequestAQuotePage() {
  return <div>
      <Navbar />
      <Quote />
      <Footer />
    </div>;
}